module.exports = __webpack_public_path__ + "img/1F55A.dac6308f.svg";